module.exports = __webpack_public_path__ + "img/default-head.ce6f5ea4.png";